<template>
  <div class="header">
    <router-link to="/" class="logo">lewismckeown.com</router-link>
    <div class="header-right">
      <router-link to="/">Home</router-link>
      <router-link to="/cv">CV</router-link>
      <router-link to="/projects">Projects</router-link>
      <router-link to="/thesis">Dissertation</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Header',
  props: {
    msg: String
  }
}
</script>

<style scoped>
.header {
  overflow: hidden;
}
.header h1 {
  padding-top: 2em;
} 

.header a {
  float: left;
  color: #565656;
  text-align: center;
  padding: 2em;
  text-decoration: none;
  padding-bottom: none;
  font-size: 18px; 
  line-height: 1em;
}

.header a:hover {
  color: black;
  border-bottom: 2px solid black;
}

.router-link-exact-active {
  font-weight: bold;
  border-bottom: 2px solid black;
  color: black !important;
}

.logo.router-link-exact-active {
  background-color: white;
  color: black;
  border-bottom: 2px solid white;
}

.header a.logo {
  font-size: 25px;
  color: black;
  font-weight: bold;
  padding-top: 1em;
  border-bottom: none;
  padding-left: 1em;
  
}
.header a.logo:hover {
  font-size: 25px;
  color: black;
  font-weight: bold;
  padding-top: 1em;
  border-bottom: none;
}

.header-right {
  float: right;
}

@media screen and (max-width: 500px) {
  .header a {
    float: none;
    display: block;
    text-align: left;
    width: 100%;
  }
  .header-right {
    float: none;
    width: 100%;
  }
}
</style>
